import { RepositoryFactory } from '../repositories/RepositoryFactory';

const guestRepository = RepositoryFactory.get('guest')

const guest = {
    namespaced: false,
    state: {
        error: null
    },
    mutations: {
        error (state, status) {
            state.error = status
        }
    },
    actions: {

        updateGuest ({ commit }, payload) {
            console.log('payload', payload)
            commit('start_loading')
            return guestRepository.updateGuest(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { commit('stop_loading') });
        },
        getGuestAid ({ commit }, aid) {

            return guestRepository.getGuestAid(aid)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getGuest ({ commit }, guest_id) {
            return guestRepository.getGuest(guest_id)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getOldChats ({ commit }) {
            return guestRepository.getOldChats()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
    },
    getters: {

    }

}

export default guest